import Control from "../Control";

const SavedSEPAs = ({
  paymentMethods,
  selectedPaymentMethod,
  setSelectedPaymentMethod,
}) => {
  return paymentMethods.find((p) => p.type == "SEPA") ? (
    <Control
      type="btnList"
      itemClassName={"justify-content-start"}
      datas={paymentMethods
        .filter((p) => p.type == "SEPA")
        .map((p) => ({
          ...p,
          icon: " pf-sepa",
        }))}
      dataIndex="paymentMethodId"
      dataLabel="info"
      dataIconSet="pf p-2 bg-success text-white rounded mr-2"
      dataIcon="icon"
      value={selectedPaymentMethod}
      change={(e) => setSelectedPaymentMethod(e.target.value)}
    />
  ) : (
    <div className="text-muted font-italic">aucun IBAN enregistré</div>
  );
};

export default SavedSEPAs;
